import React, { FunctionComponent } from "react";
import Loader from "react-loader-spinner";
import theme from "themes/simple-theme";

interface IProps {
  color?: string;
  height?: number;
  width?: number;
}

const ThreeDots: FunctionComponent<IProps> = ({
  height = 60,
  width = 80,
  color = theme.color.white
}) => <Loader type="ThreeDots" color={color} height={height} width={width} />;
export default ThreeDots;



// WEBPACK FOOTER //
// ./src/components/common/Loader/ThreeDots.tsx